<template>
    <div class="news-list-component">
        <!-- News list -->
        <div class="news-list">
            <loader ref="loader"></loader>

            <div v-if="news.length > 1">
                <news-list-item
                    v-for="article in news"
                    :key="article.newsLink"
                    :newsHeadline="article.newsTitle"
                    :newsText="article.newsDescription"
                    :newsHref="article.newsLink"
                    :newsDate="article.newsDate"
                />
            </div>
        </div>
    </div>
</template>

<script>
import NewsListItem from './NewsListItem';
import Loader from './Loader';

export default {
    components: {
        NewsListItem,
        Loader,
    },
    props: {
        news: {
            type: Array,
            default: () => [],
        },
    },
    mounted: function () {
        this.$refs.loader.show();
    },
    watch: {
        news: function (newVal) {
            if (newVal.length > 0) {
                this.$refs.loader.hide();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.news-list-component {
    margin: $mar-xl 0;
}
.news-list {
    position: relative;
    min-height: 50px; /* for the loader */
    overflow: hidden;
}
</style>
